import { render, staticRenderFns } from "./GraduateInfo.vue?vue&type=template&id=4ef55058"
import script from "./GraduateInfo.vue?vue&type=script&lang=js"
export * from "./GraduateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports